export const fixSingleThoughtTopic = (topic: string) =>
  topic.replaceAll("-", "")
